module.exports = __webpack_public_path__ + "2fe336f69ca49840c83a8134dbfd3c41.svg";